import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';
import { transformIntoQueryParamString } from '@old/utils/service';

import { AssignTagsPayload, AssignTagsResponse } from './silobag-tag.types';

export async function assignSilobagTagsService({ query: rawQuery, body }: AssignTagsPayload) {
  const query = transformIntoQueryParamString(rawQuery);

  const { response, data } = await BACKEND.put<AssignTagsResponse>(ENDPOINT.SILOBAG_TAGS, { query, body });

  return {
    response,
    summary: data,
  };
}
